import React from 'react';
import LegalLayout from './LegalLayout';

const SUPPORT_EMAIL = 'destek@dekosta.com';
const PRIVACY_EMAIL = 'privacy@dekosta.com';

const Kvkk = () => (
  <LegalLayout title="KVKK Aydınlatma Metni" lastUpdated="2026-05-24">
    <section>
      <h2 className="text-white font-semibold mb-2">Veri sorumlusu</h2>
      <p>
        DEKOSTA hizmetinin işletmecisi sıfatıyla kişisel verilerinizin işlenmesinden sorumludur. İletişim:{' '}
        <a href={`mailto:${PRIVACY_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {PRIVACY_EMAIL}
        </a>
        .
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">İşlenen kişisel veri kategorileri</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <strong className="text-gray-200">Kimlik:</strong> e-posta adresi, görünür ad, otomatik üretilen
          kullanıcı adı, varsa Google profil bilgisi.
        </li>
        <li>
          <strong className="text-gray-200">İşlem güvenliği:</strong> hashlenmiş parola, oturum token&apos;ı,
          IP adresi, brute-force tespiti için tutulan zaman damgaları.
        </li>
        <li>
          <strong className="text-gray-200">Müşteri işlem:</strong> aktive edilen kart kodları, envanter,
          koleksiyon ilerlemesi, başarımlar, görevler, arkadaşlık ilişkileri.
        </li>
        <li>
          <strong className="text-gray-200">Görsel/işitsel:</strong> kamera ile yazılı aktivasyon kodu OCR
          okuması sırasında alınan görüntü kareleri yalnız cihaz üzerinde işlenir, sunucuya yüklenmez.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">İşleme amacı</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Hizmetin sunulması (hesap, koleksiyon, aktivasyon)</li>
        <li>Bilgi güvenliği süreçlerinin yürütülmesi</li>
        <li>Faaliyetlerin mevzuata uygun yürütülmesi</li>
        <li>İletişim ve destek faaliyetlerinin yürütülmesi</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Hukuki sebep (KVKK m.5)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Sözleşmenin kurulması ve ifası</li>
        <li>Veri sorumlusunun meşru menfaati</li>
        <li>Açık rıza (opsiyonel pazarlama iletişimi için)</li>
        <li>Hukuki yükümlülük (audit kayıtları)</li>
      </ul>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Aktarım</h2>
      <p>
        Verileriniz hizmetin sunulabilmesi için zorunlu olduğu ölçüde aşağıdaki bulut/altyapı
        sağlayıcılarına aktarılır:
      </p>
      <ul className="list-disc pl-5 space-y-1 mt-2">
        <li>MongoDB Atlas (veritabanı — AWS US-West bölgesi)</li>
        <li>Railway (uygulama sunucusu — US-West bölgesi)</li>
        <li>Vercel (frontend CDN — global)</li>
        <li>Resend (e-posta servisi)</li>
        <li>Google Identity (opsiyonel OAuth)</li>
      </ul>
      <p className="mt-2">
        Yurt dışına aktarım söz konusu olduğundan KVKK m.9 kapsamında açık rızanız alınır (kayıt
        formundaki KVKK onay kutusu).
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Toplama yöntemi</h2>
      <p>
        Veriler doğrudan sizin tarafınızdan (kayıt formu, profil bilgileri, kart aktivasyonu) ve sistemin
        otomatik kayıtları (oturum token&apos;ı, IP, audit log) yoluyla elektronik ortamda toplanır.
      </p>
    </section>

    <section>
      <h2 className="text-white font-semibold mb-2">Haklarınız (KVKK m.11)</h2>
      <p>Aşağıdaki haklarınızı destek e-postası üzerinden kullanabilirsiniz:</p>
      <ul className="list-disc pl-5 space-y-1 mt-2">
        <li>Kişisel verinin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içi/dışı aktarılan üçüncü kişileri öğrenme</li>
        <li>Eksik/yanlış işlenmişse düzeltilmesini isteme</li>
        <li>Silinmesini veya yok edilmesini isteme</li>
        <li>İşleme sonucu aleyhe çıkan sonuca itiraz etme</li>
        <li>Zarar halinde tazminat isteme</li>
      </ul>
      <p className="mt-3">
        Talep:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">
          {SUPPORT_EMAIL}
        </a>
        . Yanıt süresi azami 30 gün.
      </p>
    </section>

    <p className="text-xs text-gray-600 pt-4 border-t border-white/10">
      Bu aydınlatma metni 6698 sayılı Kişisel Verilerin Korunması Kanunu m.10 kapsamında hazırlanmıştır.
    </p>
  </LegalLayout>
);

export default Kvkk;
